import React from "react";
import { motion } from "framer-motion";
import founderImg from "../assets/founder2.png"; // replace with your own image

export default function Founder() {
  return (
    <section
      id="founder"
      className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col md:flex-row items-center gap-12"
    >
      {/* Founder Image */}
      <motion.img
        src={founderImg}
        alt="Founder"
        className="w-40 h-40 md:w-56 md:h-56 object-cover rounded-full shadow-lg"
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      />

      {/* Founder Info */}
      <div className="text-center md:text-left">
        <motion.h3
          className="text-3xl font-bold text-slate-900 dark:text-white mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Meet the Founder
        </motion.h3>
        <motion.p
          className="text-lg text-slate-700 dark:text-slate-300 max-w-xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Hi, I’m <span className="font-semibold">Bikashyu</span> 👋 — a web
          developer who loves traveling, making videos, and building apps.  
          With <span className="font-semibold">QuickCaptionIO</span>, you can
          simply type a few random words or hashtags, and our AI will instantly
          turn them into ready-to-post captions and trending hashtags.  
          My goal is to save you time and make content creation fun and easy.
        </motion.p>
      </div>
    </section>
  );
}
